import { inject, Injectable } from '@angular/core';
import { WINDOW_REF } from '../browser/window-ref.token';
import { StorageService } from './storage.service';

@Injectable()
export class SessionStorageService extends StorageService {
  storage = inject(WINDOW_REF).sessionStorage;
}
